/* ─────────────────────────────────────────────────────────────────────────
 * Contact — the brief, filled in on the desk.
 *
 * Shaped the way the About page's data is shaped: short, concrete, and in the
 * photographer's own voice. The photographs are pulled from the same graded
 * roll the section sells, so this page cannot drift from the work either.
 * ───────────────────────────────────────────────────────────────────────── */

export interface Fact {
    k: string
    v: string
}

export interface Step {
    n: string
    name: string
    body: string
}

/** The frame taped beside the form. Rome, mid-shoot, one lamp. */
export const CONTACT_FRAME = {
    src: 'cinematic-03.jpg',
    caption: 'BRIEF ON THE TABLE — ROME, 2024'
}

/** Budget bands, as they get said out loud on the call. */
export const BUDGETS: string[] = [
    'Under 3k',
    '3–8k',
    '8–20k',
    '20k and up',
    'Not worked out yet'
]

/** What happens after the sheet leaves your hands. Three, not five. */
export const AFTER: Step[] = [
    {
        n: '01',
        name: 'A reply within two days',
        body: 'From me, not an assistant, and never a template. If the job is not for me I will say so and tell you who is.'
    },
    {
        n: '02',
        name: 'Twenty minutes on a call',
        body: 'No mood board. You tell me what the photographs are for and what happens if they are wrong.'
    },
    {
        n: '03',
        name: 'A look, and a number',
        body: 'One of the five, three test frames graded through the stock the job will run on, and a fee with nothing hidden under it.'
    }
]

/** Pinned beside the form, so nobody has to ask in the message field. */
export const NOTES: Fact[] = [
    { k: 'Reply', v: 'Two working days, usually the same one' },
    { k: 'Booking', v: 'Six to eight weeks out' },
    { k: 'Minimum', v: 'Two days once a flight is involved' },
    { k: 'Travel', v: 'Lisbon based, works anywhere with a runway' }
]
